import React, { useRef, useState, useEffect } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import { objectMap } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { validateFiles } from 'srcReact/helpers/fileHelper'
import { isEmpty } from 'srcReact/helpers/validator'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function ImagePicker({
  containerCss,
  uploadFileCallback,
  allowMultiple,
  filesLimit,
  allowedImageTypes = '',
  allowedImageSizeInMB,
  allowedDocumentTypes = '',
  allowedDocumentSizeInMB,
  getFileError,
  iconStyle,
  imageDataUrls = [],
  imagesToUpload = [],
  allowDocs = true,
  allowImages = true,
  iconText,
  type,
  handleShowNewsFeedPopup,
  isStatic
}) {
  const fileInputRef = useRef(null)
  const [errorMessage, setErrorMessage] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    if (errorMessage.length > 0) {
      getFileError(errorMessage)
    }
  }, [errorMessage])
  useEffect(() => {
    if (imagesToUpload && imagesToUpload.length === 0 && imageDataUrls && imageDataUrls.length === 0) {
      fileInputRef.current.value = ''
    }
  }, [imagesToUpload, imageDataUrls])

  const validateFile = (files) => {
    setErrorMessage('')

    const fileErrorMessage = validateFiles(files, true, true)
    if (isEmpty(fileErrorMessage)) {
      return true
    }

    switch (fileErrorMessage) {
      case 'FILE_COUNT_ERROR':
        setErrorMessage(t('messenger.clientErrors.fileCountError', { filesLimit: filesLimit }))
        break
      case 'FILE_TYPE_ERROR':
        setErrorMessage(t('messenger.clientErrors.fileExtError'))
        break
      case 'IMG_SIZE_ERROR':
        setErrorMessage(
          t('messenger.clientErrors.imageFileSizeError', { imageFileSize: appConstantSettings.MAX_IMAGE_SIZE_MB })
        )
        break
      case 'DOC_SIZE_ERROR':
        setErrorMessage(
          t('messenger.clientErrors.docFileSizeError', { docFileSize: appConstantSettings.MAX_DOC_SIZE_MB })
        )
        break
    }
    return false
  }
  const selectFile = (e) => {
    const files = e.target.files
    if (validateFile(files)) {
      const filesArray = objectMap(files, (file) => file, true)
      uploadFileCallback(filesArray)
    }
  }
  const openFileDialog = (e) => {
    e.stopPropagation()
    if (type === 'feed') {
      handleShowNewsFeedPopup(fileInputRef, true)
      return
    }
    fileInputRef.current.click()
  }
  const getAcceptedExtensions = () => {
    let acceptedImages = ''
    let acceptedDocs = ''
    if (allowImages) {
      acceptedImages =
        allowedImageTypes.length > 0 &&
        allowedImageTypes
          .split(',')
          .map((type) => `.${type}`)
          .join(', ')
    }
    if (allowDocs) {
      acceptedDocs =
        allowedDocumentTypes.length > 0 &&
        allowedDocumentTypes
          .split(',')
          .map((type) => `.${type}`)
          .join(', ')
    }

    if (allowImages && allowDocs) {
      return `${acceptedImages}, ${acceptedDocs}`
    } else if (allowImages) {
      return acceptedImages
    } else if (allowDocs) {
      return acceptedDocs
    } else {
      return ''
    }
  }
  return (
    <button
      data-id='filePicker'
      type='button'
      aria-label={t('messenger.selectFile')}
      className={`${styles.container} ${containerCss} ${iconText && styles.borderedContainer}`}
      onClick={(e) => !isStatic && openFileDialog(e)}>
      {allowImages && !allowDocs ? (
        <Icon name='picture' styleModifier={`${styles.paperclipIcon} ${iconStyle}`} />
      ) : (
        <Icon name='paperclip24' styleModifier={`${styles.paperclipIcon} ${iconStyle}`} />
      )}
      <span className={styles.iconText}>{iconText}</span>

      <input
        ref={fileInputRef}
        type='file'
        className={styles.inputFile}
        multiple
        onChange={selectFile}
        accept={getAcceptedExtensions()}
        // {...(allowMultiple && multiple)}
      />
    </button>
  )
}
